// services/ris.js - API service for RIS-consolidated features
// Handles patients, orders, procedures, departments, referrers
import api from './api';

// =====================================================
// PATIENTS
// =====================================================
export const patientService = {
  search: (params) => api.get('/patients', { params }),
  getById: (id) => api.get(`/patients/${id}`),
  getByMrn: (mrn) => api.get(`/patients/mrn/${mrn}`),
  register: (data) => api.post('/patients', data),
  update: (id, data) => api.put(`/patients/${id}`, data),
  delete: (id) => api.delete(`/patients/${id}`),
  // NDPA 2023 s.26 / s.35 — consent
  getConsent: (id) => api.get(`/patients/${id}/consent`),
  withdrawConsent: (id, reason) => api.post(`/patients/${id}/consent/withdraw`, { reason })
};

// =====================================================
// ORDERS
// =====================================================
export const orderService = {
  list: (params) => api.get('/orders', { params }),
  getById: (id) => api.get(`/orders/${id}`),
  create: (data) => api.post('/orders', data),
  update: (id, data) => api.put(`/orders/${id}`, data),
  updateStatus: (id, status, reason) => api.patch(`/orders/${id}/status`, { status, reason }),
  assignRadiologist: (id, radiologistId, radiologistName, reason) =>
    api.patch(`/orders/${id}/assign`, { radiologistId, radiologistName, reason }),
  bulkAssignRadiologist: (orderIds, radiologistId, radiologistName, reason) =>
    api.patch('/orders/bulk-assign', { orderIds, radiologistId, radiologistName, reason }),
  getAssignmentHistory: (id) => api.get(`/orders/${id}/assignment-history`),
  cancel: (id, reason) => api.delete(`/orders/${id}`, { data: { reason } }),
  getStats: (params) => api.get('/orders/stats', { params }),
  getSchedule: (params) => api.get('/orders/schedule', { params }),
  checkAvailability: (data) => api.post('/orders/check-availability', data)
};

// =====================================================
// ROOMS / EQUIPMENT
// =====================================================
export const roomService = {
  list: (params) => api.get('/rooms', { params }),
  getById: (id) => api.get(`/rooms/${id}`),
  create: (data) => api.post('/rooms', data),
  update: (id, data) => api.put(`/rooms/${id}`, data),
  delete: (id) => api.delete(`/rooms/${id}`)
};

// =====================================================
// PROCEDURES
// =====================================================
export const procedureService = {
  list: (params) => api.get('/procedures', { params }),
  getById: (id) => api.get(`/procedures/${id}`),
  create: (data) => api.post('/procedures', data),
  update: (id, data) => api.put(`/procedures/${id}`, data),
  delete: (id) => api.delete(`/procedures/${id}`)
};

// =====================================================
// DEPARTMENTS
// =====================================================
export const departmentService = {
  list: (params) => api.get('/departments', { params }),
  getById: (id) => api.get(`/departments/${id}`),
  create: (data) => api.post('/departments', data),
  update: (id, data) => api.put(`/departments/${id}`, data),
  delete: (id) => api.delete(`/departments/${id}`)
};

// =====================================================
// REFERRERS
// =====================================================
export const referrerService = {
  list: (params) => api.get('/referrers', { params }),
  getById: (id) => api.get(`/referrers/${id}`),
  create: (data) => api.post('/referrers', data),
  update: (id, data) => api.put(`/referrers/${id}`, data),
  delete: (id) => api.delete(`/referrers/${id}`)
};
